import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import Button from "../../Component/Button/Button";
import Style from "./ClosedStore.module.css";
import { getSupplierInfo } from "../../Api/BarestServices";
import { errorToast } from "../../Toast/Toast";
const ClosedStore = () => {
  const history = useHistory();
  const[storeDetailState,setStoreDetailState]=useState()
  useEffect(() => {
    getSupllierDetails();
  }, []);
  const getSupllierDetails = async () => {
    const path = window.location.pathname.split("/");
    getSupplierInfo(path[2],(succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast(res.message)
        }else{
          setStoreDetailState(res.supplier);
        }
      }else{
        console.error(res)
      }
    })
  };
  
  return (
    <div className={Style.PageHolder}>
      <div className={Style.ImageHolder}>
      <img
            src={`https://cdn.barest.ir/supplier/logo/${storeDetailState?.logo}.jpg`}
            alt="restaurant"
          />
      </div>
      <strong>در حال حاضر {`${storeDetailState?.name}`} باز نیست!</strong>
      <strong>ساعات کاری {`${storeDetailState?.name}`}:</strong>
      <p>نوبت اول: {`${storeDetailState?.supplier_working_hours?.start_1}`} تا {`${storeDetailState?.supplier_working_hours?.end_1}`}</p>
      <p>نوبت دوم: {`${storeDetailState?.supplier_working_hours?.start_2}`} تا {`${storeDetailState?.supplier_working_hours?.end_2}`}</p>
      <Button
        Value={"بازگشت"}
        ClassBtn={"confrimBtn"}
        ClickHandler={() => history.goBack()}
      />
    </div>
  );
};

export default ClosedStore;
